import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken, logOut} from '../../../helpers/LocalStorageHelper'
import {handleError} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'GET_ORGANIZATION_STATUS_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_ORGANIZATION_STATUS_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_ORGANIZATION_STATUS_PROCESSING', processing};
}

function getOrganizationStatus(id) {
    return (dispatch) => {
        dispatch(_processing(true));
        dispatch(_error(null));

        const request = axios({

            url: apiBaseUrl(`admin/organizations/${id}/status`),
            method: "get",
            dataType: 'json',
            headers: {'Authorization': 'Bearer ' + loginToken()}
        })
            .then(function (res) {
                dispatch(_success(res.data.data));
                dispatch(_processing(false));
            }).catch(function (error) {
                if (error && error.response &&
                    error.response.status === 401) {
                    logOut()
                } else {
                    handleError(error)
                    dispatch(_error(error));
                    dispatch(_processing(false));
                }
            });

        return {
            type: 'GET_ORGANIZATION_STATUS_SUCCESS',
            payload: request
        }
    }
}


export default getOrganizationStatus;